import React from "react";
import { Link } from "react-router-dom";
import { useApp } from "@/context/AppContext";
import { LEGAL_LINKS } from "@/pages/legal/legalContent";

export default function Footer() {
  const { t, lang } = useApp();
  const year = new Date().getFullYear();
  return (
    <footer className="border-t border-line px-5 md:px-10 pt-20 pb-10" data-testid="footer">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <h2 className="font-display text-5xl md:text-7xl tracking-tight leading-[0.9]">
            Heda<br /><span className="text-accent">Gelogaeva</span>
          </h2>
          <p className="text-ink/50 font-light mt-6 max-w-sm">{t.footer.tagline}</p>
        </div>
        <div className="md:col-span-2">
          <p className="text-xs uppercase tracking-[0.24em] text-muted mb-5">{t.footer.explore}</p>
          <ul className="space-y-3 text-sm">
            <li><Link to="/" className="link-underline">{t.footer.explore === "Explore" ? "Home" : "Главная"}</Link></li>
            <li><Link to="/catalogue" className="link-underline">{t.nav.catalogue}</Link></li>
            <li><Link to="/payment" className="link-underline">{t.payment.open}</Link></li>
          </ul>
        </div>
        <div className="md:col-span-2">
          <p className="text-xs uppercase tracking-[0.24em] text-muted mb-5">{lang === "ru" ? "Правовая информация" : "Legal"}</p>
          <ul className="space-y-3 text-sm">
            {LEGAL_LINKS.map((l) => (
              <li key={l.slug}>
                <Link to={`/legal/${l.slug}`} data-testid={`footer-legal-${l.slug}`} className="link-underline">{l.label[lang] || l.label.en}</Link>
              </li>
            ))}
          </ul>
        </div>
        <div className="md:col-span-3">
          <p className="text-xs uppercase tracking-[0.24em] text-muted mb-5">{t.footer.contactTitle}</p>
          <a
            href="https://wa.me/79263070808"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-whatsapp-eu"
            className="link-underline text-sm block mb-2"
          >
            {t.footer.whatsapp} ({lang === "ru" ? "ЕВР" : "EU"}) · +7 926 307 08 08
          </a>
          <a
            href="https://wa.me/17542712282"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-whatsapp-us"
            className="link-underline text-sm block mb-2"
          >
            {t.footer.whatsapp} ({lang === "ru" ? "США" : "US"}) · +1 754-271-2282
          </a>
          <a href="https://t.me/s/gelogaevaheda" target="_blank" rel="noopener noreferrer" data-testid="footer-telegram-1" className="link-underline text-sm block mb-2">
            Telegram · @gelogaevaheda
          </a>
          <a href="https://t.me/s/hedageogaeva" target="_blank" rel="noopener noreferrer" data-testid="footer-telegram-2" className="link-underline text-sm block mb-2">
            Telegram · @hedageogaeva
          </a>
          <a href="https://www.instagram.com/gelogaeva_gold/" target="_blank" rel="noopener noreferrer" data-testid="footer-instagram" className="link-underline text-sm block">
            Instagram · @gelogaeva_gold
          </a>
          <a href="mailto:support@buyheda.com" data-testid="footer-email" className="link-underline text-sm block mt-2">
            {t.footer.email} · support@buyheda.com
          </a>
        </div>
      </div>
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-2 mt-20 pt-6 border-t border-line text-[11px] uppercase tracking-[0.18em] text-muted">
        <span>© {year} Heda Gelogaeva</span>
        <span>{t.footer.rights}</span>
      </div>
    </footer>
  );
}
